import { Chart } from "@scuf/charts";
import { Card } from "@scuf/common";
import { useEffect, useState } from "react";
import { getConsolidadoPeriodo } from "../../../services/services";
import formatDateType from "../../../utils/formatDateType";
import LoadingChart from "./loadingChart";
import useYAxisTitle from "../../../hooks/useYAxisTitle";

export default function SiliceConsumida(props) {
  const SECUENCIA = 4;

  // Objeto por default de los states
  const defaultObject = Object.assign({
    value: [],
    fecha: [],
  });

  const [consumoSilice, setConsumoSilice] = useState(defaultObject);
  const [yAxisTitleLeft, yAxisTitleRight] = useYAxisTitle(props.periodo);

  const [siliceSemana, setSiliceSemana] = useState(defaultObject);
  const [siliceMes, setSiliceMes] = useState(defaultObject);
  const [siliceAno, setSiliceAno] = useState(defaultObject);

  const [consumoSiliceSemana, setConsumoSiliceSemana] = useState(defaultObject);
  const [consumoSiliceMes, setConsumoSiliceMes] = useState(defaultObject);
  const [consumoSiliceAno, setConsumoSiliceAno] = useState(defaultObject);

  const [isLoading, setIsLoading] = useState(true);

  // Efecto que se ejecturara cada vez que cambien las props
  useEffect(() => {
    async function fetchData() {
      setIsLoading(true);
      const { data } = await getConsolidadoPeriodo({
        secuencia: SECUENCIA,
        periodo: props.periodo,
      });


        console.log('silice consumida: ', data)
      populateAno(data);
      populateConsumoSilice(data);
      populateSemana(data);
      populateMes(data);

      populateConsumoSiliceSemana(data);
      populateConsumoSiliceMes(data);
      populateConsumoSiliceAño(data);

      setIsLoading(false);
    }

    fetchData();
  }, [props]);

  function populateSemana(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "Sílice Consumida: Turno"
    );

    arrData.forEach((element) => {
      arrValues.push(element.ValorSemana);
      arrFechas.push(element.fecha);
    });

    setSiliceSemana({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateMes(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "Sílice Consumida: Turno"
    );

    arrData.forEach((element) => {
      arrValues.push(element.ValorMes);
      arrFechas.push(element.fecha);
    });

    setSiliceMes({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateAno(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "Sílice Consumida: Turno"
    );

    arrData.forEach((element) => {
      arrValues.push(element.ValorAgno);
      arrFechas.push(element.fecha);
    });

    setSiliceAno({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateConsumoSilice(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "Consumo Sílice: Turno"
    );

    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(element.fecha);
    });

    console.log('populateConsumoSilice: ',arrData)
    setConsumoSilice({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateConsumoSiliceSemana(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "Consumo Sílice: Turno"
    );

    arrData.forEach((element) => {
      arrValues.push(element.ValorSemana);
      arrFechas.push(element.fecha);
    });

    setConsumoSiliceSemana({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateConsumoSiliceMes(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "Consumo Sílice: Turno"
    );

    arrData.forEach((element) => {
      arrValues.push(element.ValorMes);
      arrFechas.push(element.fecha);
    });

    setConsumoSiliceMes({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateConsumoSiliceAño(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "Consumo Sílice: Turno"
    );

    arrData.forEach((element) => {
      arrValues.push(element.ValorAgno);
      arrFechas.push(element.fecha);
    });

    setConsumoSiliceAno({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  return (
    <>
      {isLoading ? (
        <LoadingChart />
      ) : (
        <Card>
          <Card.Content>
            <Chart title="Sílice Consumida" zoom="x">
              <Chart.Column name="Consumo Sílice" data={consumoSilice.value} />

              {
                "----------------------------- Consumo Silice ----------------------------------------"
              }

              {props.periodo === "S" ? (
                <Chart.Column
                  name="Consumo Sílice: Semana"
                  data={consumoSiliceSemana.value}
                  yAxis={0}
                />
              ) : (
                <></>
              )}

              {props.periodo === "M" ? (
                <Chart.Column
                  name="Consumo Sílice: Mes"
                  data={consumoSiliceMes.value}
                  yAxis={0}
                />
              ) : (
                <></>
              )}

              {props.periodo === "A" ? (
                <Chart.Column
                  name="Consumo Sílice: Año"
                  data={consumoSiliceAno.value}
                  yAxis={0}
                />
              ) : (
                <></>
              )}

              <Chart.XAxis
                categories={
                  props.periodo === "S"
                    ? formatDateType(siliceSemana.fecha, "S")
                    : props.periodo === "M"
                    ? formatDateType(siliceSemana.fecha, "M")
                    : formatDateType(siliceSemana.fecha, "A")
                }
              />

              <Chart.YAxis
                labelSuffix=" t/h"
                title={`Consumo Silice ${yAxisTitleLeft}, t/h`}
                lineWidth={2}
                lineColor="white"
              />

              <Chart.Tooltip valueSuffix=" t/h" />
            </Chart>
          </Card.Content>
        </Card>
      )}
    </>
  );
}
